import { useTrackMutation } from '@mote/api'
import { reallyTruthy, useEventListener } from '@mote/helpers'
import { WEB_STORAGE_PREFIX_KEYS } from '@mote/helpers/constants'
import PropTypes from 'prop-types'
import React from 'react'
import {
  broadcastToExtensions,
  deleteAllDataInStorage,
  readAllDataInStorage
} from '../shared/Auth'

export const AuthContext = React.createContext()

const propTypes = {
  children: PropTypes.object.isRequired
}

export const AuthProvider = ({ children }) => {
  const isMountedRef = React.useRef(false)
  const { mutate: track } = useTrackMutation()
  const [user, setUser] = React.useState(() => {
    const authData = readAllDataInStorage()
    if (!authData.accessToken) return null

    return authData
  })

  const updateUser = React.useCallback((user = null) => {
    setUser(user)
  }, [])

  const logout = React.useCallback((forced = false, isExtension = false) => {
    track({
      variables: {
        event: 'Authentication: Log Out',
        forced,
        origin: isExtension ? 'extension' : 'web'
      }
    })
    broadcastToExtensions('logout', {})
    deleteAllDataInStorage()
    setUser(null)

    if (window.analytics) {
      window.analytics.reset()
    } else {
      console.error('No analytics.js to reset()')
    }
  }, [])

  const handleStorageChange = React.useCallback(
    event => {
      if (!isMountedRef.current || !user) return
      if (event.key !== `${WEB_STORAGE_PREFIX_KEYS}accessToken`) return
      if (reallyTruthy(event.newValue)) return

      setUser(null)
    },
    [user]
  )

  useEventListener('storage', handleStorageChange)

  React.useEffect(() => {
    isMountedRef.current = true

    return () => {
      isMountedRef.current = false
    }
  }, [])

  return (
    <AuthContext.Provider value={{ user, updateUser, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

AuthProvider.propTypes = propTypes
